import { reduce } from "et3-type-guards";
import { TReportSubjectsDetailsProps } from "../../../../../Types";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import UserReportDetails from "./user-reports-details";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import TBWShortcutActions from "./tbw-shortcut-actions";

const ReportSubjectsDetails =
  withLiteObserverAndTheme<TReportSubjectsDetailsProps>((props) => {
    const { report, theme, pendingReport, pageName } = props;
    const { colors } = theme;

    const reporterPaymentData = reduce(() => report.reporterPaid, {
      isReporterPaidVIP: false,
      isReporterPaidPlus: false,
      isReporterPaidAlkhattabat: false,
      isReporterPaidBoost: false,
      isReporterPaidRewind: false,
      isReporterPaidSilver: false,
      isReporterPaidGold: false,
      isReporterPaidBlack: false,
      isReporterPaidPlatinum: false,
      isReporterPaidPower: false,
      isReporterSubscribedVIP: false,
      isReporterSubscribedPlus: false,
      isReporterSubscribedAlkhattabat: false,
      isReporterSubscribedBoost: false,
      isReporterSubscribedRewind: false,
      isReporterSubscribedSilver: false,
      isReporterSubscribedGold: false,
      isReporterSubscribedBlack: false,
      isReporterSubscribedPlatinum: false,
      isReporterSubscribedPower: false,
      wasReporterStripeUser: false
    });

    const reportedPaymentData = reduce(() => report.reportedPaid, {
      isReportedPaidVIP: false,
      isReportedPaidPlus: false,
      isReportedPaidAlkhattabat: false,
      isReportedPaidBoost: false,
      isReportedPaidRewind: false,
      isReportedPaidSilver: false,
      isReportedPaidGold: false,
      isReportedPaidBlack: false,
      isReportedPaidPlatinum: false,
      isReportedPaidPower: false,
      isReportedSubscribedVIP: false,
      isReportedSubscribedPlus: false,
      isReportedSubscribedAlkhattabat: false,
      isReportedSubscribedBoost: false,
      isReportedSubscribedRewind: false,
      isReportedSubscribedSilver: false,
      isReportedSubscribedGold: false,
      isReportedSubscribedBlack: false,
      isReportedSubscribedPlatinum: false,
      isReportedSubscribedPower: false,
      wasReportedStripeUser: false
    });

    const reporterTester = reduce(() => report.reporterTester, false);
    const reportedTester = reduce(() => report.reportedTester, false);

    const reporter = {
      id: reduce(() => report.reporterId, 0),
      username: reduce(() => report.reporterUsername, ""),

      gender: reduce(() => report.reporterGender, "f"),
      createdOn: reduce(() => report.reporterCreatedOn, ""),
      loginCount: reduce(() => report.reporterLoginCount, 0),
      tempBanCount: reduce(() => report.reporterTempBanCount, 0),
      warnCount: reduce(() => report.reporterWarnCount, 0)
    };

    const reported = {
      id: reduce(() => report.reportedId, 0),
      username: reduce(() => report.reportedUsername, ""),

      gender: reduce(() => report.reportedGender, "m"),
      createdOn: reduce(() => report.reportedCreatedOn, ""),
      loginCount: reduce(() => report.reportedLoginCount, 0),
      tempBanCount: reduce(() => report.reportedTempBanCount, 0),
      warnCount: reduce(() => report.reportedWarnCount, 0)
    };

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        width={1300}
        height={620}
        withShadow={false}
        alignItems="center"
        fDirection="column"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          flexWrap: "wrap"
        }}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          width={1300}
          height={620}
          withShadow={false}
          alignItems="center"
          fDirection="column"
          justifyContent="flex-start"
          color={colors.all.transparent}
          style={{
            flexWrap: "wrap"
          }}
          onClick={() => {}}
        >
          <UserReportDetails
            type={"REPORTER"}
            isTester={reporterTester}
            wasStripeUser={reporterPaymentData.wasReporterStripeUser}
            user={reporter}
            isPaidVIP={reporterPaymentData.isReporterPaidVIP}
            isPaidPlus={reporterPaymentData.isReporterPaidPlus}
            isPaidAlKhattabat={reporterPaymentData.isReporterPaidAlkhattabat}
            isPaidBoost={reporterPaymentData.isReporterPaidBoost}
            isPaidRewind={reporterPaymentData.isReporterPaidRewind}
            isPaidSilver={reporterPaymentData.isReporterPaidSilver}
            isPaidGold={reporterPaymentData.isReporterPaidGold}
            isPaidBlack={reporterPaymentData.isReporterPaidBlack}
            isPaidPlatinum={reporterPaymentData.isReporterPaidPlatinum}
            isPaidPower={reporterPaymentData.isReporterPaidPower}
            isSubscribedVIP={reporterPaymentData.isReporterSubscribedVIP}
            isSubscribedPlus={reporterPaymentData.isReporterSubscribedPlus}
            isSubscribedAlkhattabat={
              reporterPaymentData.isReporterSubscribedAlkhattabat
            }
            isSubscribedBoost={reporterPaymentData.isReporterSubscribedBoost}
            isSubscribedRewind={reporterPaymentData.isReporterSubscribedRewind}
            isSubscribedSilver={reporterPaymentData.isReporterSubscribedSilver}
            isSubscribedGold={reporterPaymentData.isReporterSubscribedGold}
            isSubscribedBlack={reporterPaymentData.isReporterSubscribedBlack}
            isSubscribedPlatinum={
              reporterPaymentData.isReporterSubscribedPlatinum
            }
            isSubscribedPower={reporterPaymentData.isReporterSubscribedPower}
          />

          <UserReportDetails
            type={"REPORTED"}
            isTester={reportedTester}
            wasStripeUser={reportedPaymentData.wasReportedStripeUser}
            user={reported}
            isPaidVIP={reportedPaymentData.isReportedPaidVIP}
            isPaidPlus={reportedPaymentData.isReportedPaidPlus}
            isPaidAlKhattabat={reportedPaymentData.isReportedPaidAlkhattabat}
            isPaidBoost={reportedPaymentData.isReportedPaidBoost}
            isPaidRewind={reportedPaymentData.isReportedPaidRewind}
            isPaidSilver={reportedPaymentData.isReportedPaidSilver}
            isPaidGold={reportedPaymentData.isReportedPaidGold}
            isPaidBlack={reportedPaymentData.isReportedPaidBlack}
            isPaidPlatinum={reportedPaymentData.isReportedPaidPlatinum}
            isPaidPower={reportedPaymentData.isReportedPaidPower}
            isSubscribedVIP={reportedPaymentData.isReportedSubscribedVIP}
            isSubscribedPlus={reportedPaymentData.isReportedSubscribedPlus}
            isSubscribedAlkhattabat={
              reportedPaymentData.isReportedSubscribedAlkhattabat
            }
            isSubscribedBoost={reportedPaymentData.isReportedSubscribedBoost}
            isSubscribedRewind={reportedPaymentData.isReportedSubscribedRewind}
            isSubscribedSilver={reportedPaymentData.isReportedSubscribedSilver}
            isSubscribedGold={reportedPaymentData.isReportedSubscribedGold}
            isSubscribedBlack={reportedPaymentData.isReportedSubscribedBlack}
            isSubscribedPlatinum={
              reportedPaymentData.isReportedSubscribedPlatinum
            }
            isSubscribedPower={reportedPaymentData.isReportedSubscribedPower}
          />
        </ET3Div>

        <ET3Div
          width={0}
          height={0}
          alignItems={"center"}
          fDirection={"column"}
          style={{}}
          color={""}
          justifyContent={"center"}
          withShadow={false}
          isExtendable={false}
          isScrollable={false}
          onClick={() => {}}
        >
          {pendingReport ? (
            <>
              <Et3Margin top={50} right={10} bottom={0} left={0} />
              <TBWShortcutActions
                reportID={report.reportId}
                reportedID={report.reportedId}
                reportedUUID={report.reportedUUID}
                pageName={pageName}
              />
            </>
          ) : null}
        </ET3Div>
      </ET3Div>
    );
  });
export default ReportSubjectsDetails;
